import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Referral } from './referral'

export class ReferralsRepository extends BaseRepository<Referral> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'referrals', token, cache)
    }

    async report(from: Date, to: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl +
                '/referrals/report?from=' +
                from +
                '&to=' +
                to +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
